import { render } from "./ClientOtherObjectsModal.vue?vue&type=template&id=29b12f19"
import script from "./ClientOtherObjectsModal.vue?vue&type=script&lang=js"
export * from "./ClientOtherObjectsModal.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Intermark\\Intermark(mobile)\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__